import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';

export default class BankAccount extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            fromAutoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            onSetBank: this.isNull(props.OnSetBank) ? null : props.OnSetBank,
            callbackData: this.isNull(props.CallbackData) ? null : props.CallbackData,
            data: null,
            loading: true,
            pos: null,
            cheque: null,
            removedPos: [],
            removedCheque: [],
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/bankaccount/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.pos = this.getBlankPos();
                    this.state.cheque = this.getBlankCheque();
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        this.httpPost("api/v1/bankaccount/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            code: parseInt(this.state.data.record.code),
            number: this.state.data.record.number,
            bankId: this.state.data.record.bankId,
            sheba: this.state.data.record.sheba,
            branch: this.state.data.record.branch,
            groupId: this.state.data.record.groupId,
            removedCheque: this.state.removedCheque,
            removedPos: this.state.removedPos,
            poses: this.state.data.poses,
            cheques: this.state.data.cheques,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");

                    if (this.state.fromAutoComplete) {
                        if (this.isNull(this.state.onSetBankAccount)) {
                            this.state.caller.setBankAccount({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            });
                        }
                        else {
                            this.state.onSetBankAccount({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            }, this.state.caller, this.state.callbackData);
                        }
                    }
                    else
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getBlankPos() {
        return {
            id: this.uuidv4(),
            isNewItem: true,
            name: '',
            serial: ''
        };
    }
    getBlankCheque() {
        return {
            id: this.uuidv4(),
            isNewItem: true,
            numberFrom: 0,
            numberTo: 0,
            serial: 0,
            chequePrintTemplateId: this.getDefaultGuid(),
            chequePrintTemplateTitle: ''
        };
    }
    addPos() {
        if (this.isBlank(this.state.pos.name)) {
            this.showErorrMessage("لطفا نام دستگاه را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.pos.serial)) {
            this.showErorrMessage("لطفا سریال دستگاه را وارد نمایید");
            return;
        }
        this.state.data.poses.push(this.state.pos);
        this.setState({ pos: this.getBlankPos() });
    }
    addCheque() {
        if (this.isBlank(this.state.cheque.serial) || this.state.cheque.serial == 0) {
            this.showErorrMessage("لطفا سریال دسته چک را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.cheque.numberFrom) || this.state.cheque.numberFrom == 0) {
            this.showErorrMessage("لطفا شماره شروع دسته چک را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.cheque.numberTo) || this.state.cheque.numberTo == 0) {
            this.showErorrMessage("لطفا شماره اتمام دسته چک را وارد نمایید");
            return;
        }
        if (this.state.cheque.numberTo < this.state.cheque.numberFrom) {
            this.showErorrMessage("شماره اتمام بایستی بزرگتر از شماره شروع باشد");
            return;
        }
        this.state.data.cheques.push(this.state.cheque);
        this.setState({ cheque: this.getBlankCheque() });
    }
    removePos(id) {
        var t = [];
        this.state.data.poses.forEach(f => {
            if (f.id != id) {
                if (f.isNewItem == true) this.state.removedPos.push(f.id);
                t.push(f);
            }
        });
        this.state.data.poses = t;
        this.setState({ removedPos: this.state.removedPos });
    }
    removeCheque(id) {
        var t = [];
        this.state.data.cheques.forEach(f => {
            if (f.id != id) {
                if (f.isNewItem == true) this.state.removedCheque.push(f.id);
                t.push(f);
            }
        });
        this.state.data.cheques = t;
        this.setState({ removedCheque: this.state.removedPos });
    }
    setBank(e) {
        this.state.data.record.bankId = e.value;
        this.state.data.record.bankName = e.label;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close hand" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id != this.defaultGuid() ? "ویرایش اطلاعات حساب بانکی" : "افزودن حساب بانکی جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <div className="form-group">
                                            <label for="bank-name" className="title1">عنوان حساب </label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="title1">نام بانک</label><span className="red">*</span>
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={this.state.data.record.bankId !== this.getDefaultGuid() ? [{ value: this.state.data.record.bankId, label: this.state.data.record.bankName }] : null}
                                                isMulti={false}
                                                placeholder="جستجو و انتخاب بانک"
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                }
                                                //defaultOptions={[]}
                                                components={{
                                                   // DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                }}
                                                loadOptions={(inputValue, callback) => this.loadBanksOptions(inputValue, callback)}
                                                onChange={e => this.setBank(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">تفصیل</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="40" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">شماره حساب</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.number} onChange={e => this.state.data.record.number = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="40" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">شماره شبا</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.sheba} onChange={e => this.state.data.record.sheba = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="40" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="branch" className="title1">شعبه</label>
                                            <input defaultValue={this.state.data.record.branch} onChange={e => this.state.data.record.branch = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <ul className="nav nav-tabs mt-n3" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link active" data-bs-toggle="tab" href="#tab_pos" aria-selected="false" role="tab" tabindex="-1"><em className="icon ni ni-info"></em><span>دستگاه های پوز</span>
                                            </a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link" data-bs-toggle="tab" href="#tab_cheque" aria-selected="false" tabindex="-1" role="tab"><em className="icon ni ni-list-round"></em><span>دسته چکها</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="tab_pos" role="tabpanel">
                                            <div className="row" key={this.state.pos.id}>
                                                <div className="col-sm-5">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">عنوان دستگاه</label>
                                                        <input defaultValue={this.state.pos.name} onChange={e => this.state.pos.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                                    </div>
                                                </div>

                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">شماره سریال</label>
                                                        <input defaultValue={this.state.pos.serial} onChange={e => this.state.pos.serial = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="12" />
                                                    </div>
                                                </div>

                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <a className="btn btn-primary hand btn-sm" onClick={e => this.addPos()} style={{ "margin-top": "29px" }} > <i className="fa fa-plus"></i>افزودن</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12" style={{ "max-height": "250px", "overflow-y": "scroll", "padding-left": "0" }}>
                                                <table className="table table-bordered" style={{ "margin": "0" }} >
                                                    <thead>
                                                        <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                            <td>عنوان</td>
                                                            <td>سریال دستگاه</td>
                                                            <td></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.data.poses.map(p => <tr style={{ "height": "37px!important" }} >
                                                            <td style={{ "min-width": "220px" }} className="invoice-td">{p.name}</td>
                                                            <td style={{ "min-width": "220px" }} className="invoice-td">{p.serial}</td>
                                                            <td style={{ "width": "120px" }} className="invoice-td">
                                                                <a className="hand" onClick={e => this.removePos(p.id)}>حذف</a>
                                                            </td>
                                                        </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="tab-pane" id="tab_cheque" role="tabpanel">
                                            <div className="row" key={this.state.cheque.id}>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">سریال چک</label>
                                                        <input defaultValue={this.state.cheque.serial} onChange={e => this.state.cheque.serial = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="12" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">از شماره</label>
                                                        <input defaultValue={this.state.cheque.numberFrom} onChange={e => this.state.cheque.numberFrom = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="12" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">تا شماره</label>
                                                        <input defaultValue={this.state.cheque.numberTo} onChange={e => this.state.cheque.numberTo = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="12" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">الگوی چاپ</label>
                                                        <SelectAsync
                                                            style={{ "width": "100%" }}
                                                            defaultValue={this.state.cheque.chequePrintTemplateId !== this.getDefaultGuid() ? [{ value: this.state.cheque.chequePrintTemplateId, label: this.state.cheque.chequePrintTemplateTitle }] : null}
                                                            isMulti={false}
                                                            placeholder="جستجو و انتخاب الگو"
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? "نتیجه‌ای یافت نشد" : null
                                                            }
                                                            //defaultOptions={[]}
                                                            components={{
                                                                // DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            loadOptions={(inputValue, callback) => this.loadBanksOptions(inputValue, callback)}
                                                            onChange={e => {
                                                                this.state.cheque.chequePrintTemplateId = e.value;
                                                                this.state.cheque.chequePrintTemplateTitle = e.label;
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <a className="btn btn-primary btn-sm hand" onClick={e => this.addCheque()} style={{ "margin-top": "29px" }} ><i className="fa fa-plus"></i>افزودن</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12" style={{ "max-height": "250px", "overflow-y": "scroll", "padding-left": "0" }}>
                                                <table className="table table-bordered" style={{ "margin": "0" }} >
                                                    <thead>
                                                        <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }} >
                                                            <td>سریال چک</td>
                                                            <td>از شماره</td>
                                                            <td>تا شماره</td>
                                                            <td>الگوی چاپ</td>
                                                            <td></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.data.cheques.map(p => <tr style={{ "height": "37px!important" }} >
                                                            <td style={{ "min-width": "220px" }} className="invoice-td">{p.serial}</td>
                                                            <td style={{ "min-width": "110px" }} className="invoice-td">{p.numberFrom}</td>
                                                            <td style={{ "min-width": "110px" }} className="invoice-td">{p.numberTo}</td>
                                                            <td style={{ "min-width": "110px" }} className="invoice-td">{p.chequePrintTemplateTitle}</td>
                                                            <td style={{ "width": "120px" }} className="invoice-td">
                                                                <a className="hand" onClick={e => this.removeCheque(p.id)}>حذف</a>
                                                            </td>
                                                        </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف </button>
                        <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={e => this.save(e)}>
                            ذخیره
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}